
define('tmpl!core/templates/webidl/implements.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlImplements\'>{{extAttr obj indent true}}{{idn indent}}<a>{{obj.id}}</a> implements <a>{{obj.datatype}}</a>;</span>\n');});

